import {
  Component,
  Input
} from '@angular/core';

import { IdtComponentSettings, SlotSettings } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'render-piece[piece]',
  templateUrl: 'render-piece.component.html',
  styleUrls: ['./render-piece.component.scss']
})

export class RenderPieceComponent {

  @Input() public piece!: IdtComponent;
  @Input() public settings!: IdtComponentSettings;
  @Input() public country: string | undefined;
  @Input() public lang: string | undefined;
  @Input() public slot?: SlotSettings;

}
